import { cacheClear } from './cache';

export const clearCacheItems = () => {
  const keysToClear = [
    'apiToken',
    'token',
    'deepLink',
    'associateData',
    'pillarToken',
    'searchType',
    'selectedRegionName',
  ];
  cacheClear(keysToClear);
};
